import { MenuItemProps, useNotificationCount, useTranslationRoute, useTranslations } from "@bsm/component";
import { useMemo } from "react";

export const useLeftSideBarMenuGeneral = () => {

    const [
        GENERAL,
        TRANSLATION,
        NOTIFICATIONS,
        TEACHERS,
        STUDENTS,
        ADMISSIONS,
    ] = useTranslations(i18n)
    const translationRoute = useTranslationRoute();
    // const notificationCount = useNotificationCount()

    return  {
        className: "menu-item-category",
        items: [
            // process.env.REACT_APP_ENV === 'development' ? {
            //     label: TRANSLATION,
            //     link: translationRoute("admin/translation"),
            //     startIcon: "fa-solid fa-language",
            // } : undefined,
            {
                label: STUDENTS,
                link: translationRoute("admin/students"),
                startIcon: "fa-solid fa-users",
            },
            {
                label: ADMISSIONS,
                link: translationRoute("admin/admissions"),
                startIcon: "fa-solid fa-user-plus",
            },
            // {
            //     label: TEACHERS,
            //     link: translationRoute("admin/teachers"),
            //     startIcon: "fa-solid fa-chalkboard-teacher",
            // }
            // {
            //     label: NOTIFICATIONS,
            //     link: translationRoute("admin/notification"),
            //     startIcon: "fa-solid fa-bell",
            //     badge: notificationCount > 0 ? notificationCount : undefined
            // },
        ],
    }
}

const i18n = [
    'BSM.Admin.LeftSideBar.Menu.General.Label',
    'BSM.Admin.LeftSideBar.Menu.General.Translation.Label',
    'Harea.Admin.LeftSideBar.Menu.General.Notifications.Label',
    'Harea.Admin.LeftSideBar.Menu.General.Teachers.Label',
    'std_students',
    'std_admissions'
]
